'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable sort-keys, max-len */
var en = {
    // Head Data
    get_in_on_the_auction: 'Get in on the auction — bid LIVE online on art, antiques, jewelry and collectibles. Find online auctions from around the world at LiveAuctioneers.',
    bid_in_online_auctions: 'Bid in Online Auctions - LiveAuctioneers',
    // Header
    lot_number: 'Lot Number',
    lot_number_short: 'Lot #',
    starting_bid: 'Starting Bid',
    auctioneer: 'Auctioneer',
    auction: 'Auction',
    date: 'Date',

    // Crown
    directory: 'Directory',
    price_results: 'Price Results',
    news: 'News',
    help: 'Help',
    consign: 'Consign',

    // Outdated Browser Modal
    did_you_know_that_your_web_browser: 'Did you know that your web browser is a little outdated? You\'re using {formalName} version {majorVersion}.',
    browsers_for_best_experience: 'For the best LiveAuctioneers experience, please upgrade to a newer version of {chrome}, {firefox}, {safari}, or {edge}.',
    chrome: 'Google Chrome',
    edge: 'Microsoft Edge',
    firefox: 'Mozilla Firefox',
    ie: 'Microsoft Edge',
    safari: 'Apple Safari',

    // Search
    search_placeholder: 'Search for items and auction houses',
    log_in: 'Log In',
    log_out: 'Log Out',
    sign_up: 'Join',
    me: 'me',
    saved_items: 'Saved Items',
    my_bids: 'My Bids',
    my_auctions: 'My Auctions',
    won_items: 'Won Items',
    messages: 'Messages',
    saved_searches_and_alerts: 'Followed Searches and Alerts',
    followed_auctioneers: 'Followed Auctioneers',
    account_settings: 'Account Settings',
    auction_houses: 'Auction Houses',
    auction_price_results: 'Auction Price Results',
    deleted_item_1: 'is no longer available.',
    deleted_item_2: 'Create a search alert',
    deleted_item_3: 'or find similar items below.',

    // Navigation
    today: 'Today',
    art: 'Art',
    jewelry: 'Jewelry',
    asian_antiques: 'Asian Antiques',
    furniture: 'Furniture',
    collectibles: 'Collectibles',
    home_and_garden: 'Home & Garden',
    fashion: 'Fashion',

    // Home
    home: 'Home',
    online_auctions: 'Online Auctions',
    home_title: 'Bid in Online Auctions - LiveAuctioneers',
    exceptional_items_from_trusted_auction_houses: 'Exceptional Items from Trusted\nAuction Houses',
    items_auctioned: 'Items Auctioned',
    in_secure_bids: 'In Secure Bids',
    items_available: 'Items Available',
    licensed_auction_experts: 'Licensed Auction Experts',
    bidding_steps: '4 Easy Steps to Start Bidding',
    browse_by_category: 'Featured Categories',
    featured_auctions: 'Featured Auctions',
    trending_items: 'Trending Items',
    upcoming_auctions_live_count: '{liveCount} Live & Upcoming Auctions',
    upcoming_items: '{liveCount} Upcoming Items',
    past_items: 'See All {pastCount} Past Auctions',
    become_title: 'Become a Member',
    become_text: 'Join the community with the largest collection of storied objects.',
    browse_title: 'Browse',
    browse_text: 'Discover new treasures with our robust search feature or explore by category.',
    bid_title: 'Bid Anytime',
    bid_text: 'Enter an amount and place bids online anytime before an auction begins.',
    pay_title: 'Pay Only If You Win',
    pay_text: 'Complete your transaction only after you bid and win. Items are then delivered to your door.',
    explore: 'Explore',
    live_auction: 'Live Auction',
    liveauctioneers: 'LiveAuctioneers',
    sitemap: 'Sitemap',
    auctioneer_directory: 'Auctioneer Directory',
    auction_previews: 'Auction Previews',
    auction_results: 'Auction Results',
    be_informed: 'Be Informed',
    top_news: 'Top News',

    // Live Items
    watch_live_auction: 'Watch Live Auction',
    live: 'Live',
    bids: 'Bids',
    lot_passed_not_disclosed: 'Lot Passed / Not Disclosed',
    select_maximum_bid: 'Select Maximum Bid',
    increase_your_maximum_bid: 'Increase Your Maximum Bid',
    place_bid: 'Place Bid',
    automatic_bidding: 'Automatic Bidding',
    estimate: 'Estimate',
    save_item: 'Save Item',
    item_saved: 'Item Saved',
    interested_in_this_item: 'Interested in this item?',
    register_for_auction: 'Register for Auction',
    save_to_saved_items: 'Save to \'Saved Items\' to access later.',
    registration_declined: 'Registration Declined',
    account_suspended: 'Account Suspended',
    help_center: 'Help Center',
    auctioneer_has_declined_registration: 'The auctioneer has declined your registration.',
    registration_pending: 'Registration Pending',
    registration_approved: 'Registration Approved',
    download_our_app: 'Download Our App',
    and_get_bid_notifications: '& get bid notifications',
    lot_number_from: 'Lot {lotNumber} from',

    you_are_the_leading_bidder: 'You are the leading LiveAuctioneers bidder!',
    you_have_been_outbid: 'You have been outbid!',
    increase_your_chances: 'Increase your chances of winning by bidding higher.',
    increase_bid: 'Increase bid',
    bid_in_the_live_auction: 'Bid in the live auction for the best chance of winning.',
    why_cant_i_place_absentee_bid: 'Why can\'t I place an absentee bid?',
    why_cant_i_place_absentee_bid_popover_text: 'Absentee bids cannot be placed on items after the auction has started. Enter the live auction to bid on the item.',
    why_cant_i_retract_bid_popover_text: 'Bids may not be retracted after an auction has started.',
    item_lot_number: 'Lot {lotNumber}',
    search_items_helper: 'Lot # or Lot Title',
    request_online_bidding: 'Request online bidding',
    online_bidding_requested: 'Online bidding requested',
    why_cant_bid: 'Why can\'t I bid?',
    no_bid_reason: 'Online bidding isn\'t available for this catalog. To request online bidding {link} and you’ll be notified if bidding is made available.',
    request_submitted: 'Request submitted',
    request_submitted_long: 'We\'ll send you an email if the catalog begins accepting bids.',
    click_here: 'click here',

    // Ended Items
    ask_auctioneer: 'Ask Auctioneer',
    sell_similar_item: 'Sell a Similar Item',
    my_bid: 'My bid',
    bidder: 'Bidder',
    bid_history: 'Bid History',
    view_bid_history: 'View Bid history',
    lot_passed: 'Lot Passed',
    auction_ended_on: 'Auction ended on {date}',

    price: 'Price',
    bid_increment: 'Bid Increment',

    // Items
    more_items_from: 'More Items From',
    in: 'in',
    by: 'by',
    // Discover Items
    discover_items: 'Discover Items You\'ll Love',
    similar_items_auctioneer: 'Similar items from this auctioneer',
    more_auctions_auctioneer: 'More auctions from this auctioneer',
    // Curators
    auction_curated_by: 'Auction Curated By',

    // Countdown
    days: 'Days',
    day: 'Day',
    hrs: 'Hrs', // abrev for Hours
    hr: 'Hr', // abrev for Hour
    until_auction_starts: 'Until Auction Starts',
    min: 'Min',

    // Item Description:
    accepted_payment_methods: 'Accepted payment methods',
    auction_terms_and_info: 'Auction Terms & Info',
    bid_increments: 'Bid Increments',
    condition: 'Condition',
    details: 'Details',
    lot_details: 'Lot {lotNumber} Details',
    payment: 'Payment',
    terms: 'Terms',
    shipping: 'Shipping',
    shipping_and_payment: 'Shipping & Payment',

    // Similar Items
    bid_most_popular_items: 'Other Popular Items',
    bid_on_similar_items: 'Bid on Similar Items',
    // Item Card
    bid: 'Bid',
    sold_for: 'Sold for',
    lot: 'Lot',

    // Saved Items
    loading_saved_items: 'Loading Your Saved Items {loaded}/{loading}',
    empty_saved_items_message_part_1: 'Looks like you haven’t saved any items, yet.',
    empty_saved_items_message_part_2: 'To save an item, search for items you love, and tap the {heart} icon.',
    empty_saved_items_message_part_3: 'You’ll be alerted when your saved items are coming up at auction. {link}.',
    start_your_search_now: 'Start your search now',

    // Shared
    // AuctionInfo
    ask_a_question: 'Ask a Question',

    // Modals
    // HEALTHCHECK
    healthcheck_dashboard: 'Healthcheck Dashboard',
    refresh: 'Refresh',

    // Install Flash
    enjoy_the_live_auction: 'Enjoy the live auction!',
    having_trouble: 'Having trouble?',
    you_may_need_to_install_flash: 'You may need to install flash.',
    get_adobe_flash: 'Get Adobe Flash',
    we_also_recommend_trying_chrome: 'We also recommend trying Google Chrome.',
    get_google_chrome: 'Get Google Chrome',
    still_having_issues: 'Still having issues?',
    contact_our_support_team: 'Contact our Support Team',
    exit_and_continue_browsing: 'Exit and continue browsing',

    // Complete Account
    first_name: 'first name',
    last_name: 'last name',
    address_1: 'Address 1',
    address_2: 'Address 2',
    optional_parenthesis: '(optional)',
    address: 'address',
    country: 'country',
    city: 'city',
    state: 'state',
    zip_code: 'Zip/Postal Code',
    mobile_phone: 'Mobile Phone Number',
    phone_number: 'Phone',
    skip_this_step: 'Skip This Step For Now',
    complete_your_profile_to_start: 'Complete your profile to start bidding.',
    fill_out_later: 'You can always fill this out later.',
    you_must_enter_a_valid: 'You must enter a valid {token}.',
    enter_a_valid: 'Enter a valid {token}.',
    one_last_thing: 'One last thing!',
    state_province: 'state/province',

    // Complete Account Modal
    modal_zip_code: 'zip/postal code',
    modal_mobile_phone: 'mobile phone number',
    enter_a_token: 'Enter a {token}.',
    choose_from_dropdown: 'Choose a {token}.',

    // Sign up
    we_experienced_a_server_error: 'Sorry, we\'ve experienced a server error.',
    username_already_exists: 'You\'re already registered. Log in below:',
    create_account: 'Create Account',
    already_have_an_account_sign_in_here: 'Already have an account? {link}',
    sign_in_here: 'Sign in here',
    sign_up_for_a_free_membership: 'Sign up and begin your treasure hunt.',
    start_now: 'START NOW',
    terms_and_privacy: 'By signing up, you agree to our {tosLink} and {privacyLink}.',
    show: 'show',
    hide: 'hide',
    all_set: 'ALL SET',
    finish_creation: 'Yes! Finish creating your account to join the world\'s largest treasure hunt.',
    enter_a_valid_email_address: 'Please enter a valid email address.',
    enter_a_valid_password: 'Please enter a password.',

    // Login
    email_or_username: 'EMAIL ADDRESS / USERNAME',
    password: 'Password',
    submit: 'Submit',
    forgot_password: 'Forgot Password?',
    need_an_account: 'Need an account?',
    dont_have_an_account: 'Don\'t have an account?',
    sign_up_here: 'Sign up here',
    incorrect_username_or_password: 'Your username or password is incorrect.',
    incorrect_password: 'Incorrect password',
    you_must_enter_a_password: 'Please enter a password.',
    log_in_to_begin_your_treasure_hunt: 'Log in to begin your treasure hunt.',

    // Download Mobile Modals
    bid_live_using_mobile_apps: 'Bid LIVE using our mobile apps',
    enter_the_live_auction_on_our_app: 'Enter the live auction on our free {os} app',
    get_the_free_app_now: 'Get the free app now',
    no_app: 'We don\'t currently have a live bidding app for your device.',
    online_bidding_on_the_go: 'Online bidding, on the go…',
    use_our_apps_to_bid: 'Use our apps to bid on thousands of antique, fine art, and collectible items from around the world. Preview items in upcoming auctions, place bids in advance, watch and bid on live auctions and more—no matter where you are.',

    // Place Bid
    well_send_you_an_email: 'We\'ll send you an email once you\'ve been approved to bid.',
    reserve: 'reserve',
    reserve_not_met_bidder_message: 'Bid Recorded, Reserve not met.',
    reserve_bid_has_been_recorded: 'Your bid has been recorded, but the reserve hasn\'t been met. Unless the {reserve} is met, the lot will not be sold.',
    reserve_dispute_popover_text: 'The reserve is the minimum price the auction house will accept. In order to win, a bidder must meet or exceed the reserve and have the highest bid.',
    confirm_bid: 'Confirm Bid',
    bid_again: 'Bid Again',
    no_thanks: 'No Thanks',
    buyers_premium: 'Buyer\'s Premium',
    total: 'Total',
    your_maximum_bid: 'Your Maximum Bid',
    new_maximum_bid: 'New Maximum Bid',
    all_bids_must_be_approved: 'All bids must be approved by the auctioneer.',
    you_have_been_outbid_modal: 'You have been outbid by someone else\'s bid',
    you_can_still_win: 'You can still win. Bid higher.',
    by_clicking_confirm: 'By clicking Confirm you\'re committing to buy this item if you win and you are agreeing to the auctioneer\'s ',
    terms_of_sale: 'Terms of Sale.',

    // Retract Bid
    retract: 'Retract',
    retract_bid: 'Retract Bid',
    retract_long: 'We understand that sometimes things come up; however, retractions are disruptive. LiveAuctioneers may suspend bidders who frequently retract bids.',
    retract_why: 'Why are you retracting your bid?',
    retract_confirm: 'Your bid has been retracted',
    retract_dismiss: 'Back to browsing',
    retract_error: 'Error',

    //  password
    set_new_password: 'Set a new password.',
    set_password: 'SET PASSWORD',
    check_your_email: 'Check your email.',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_new_password: 'Confirm New Password',
    please_enter_email_below: 'Please enter your email below.',
    send_reset_password: 'We\'ll send you a link to reset your password.',
    email: 'Email',
    email_address: 'Email Address',
    you_must_enter_a_valid_email_address: 'Please enter a valid email address.',
    your_passwords_dont_match: 'Your passwords do not match',
    your_password_length: 'Your password must be at least 6 characters.',
    your_password_reset: 'Your password has been successfully changed.',
    send_reset_instructions: 'Send Reset Instructions',
    follow: 'Follow',
    following: 'Following',
    follow_auctioneer: 'Follow Auctioneer',
    we_have_sent: 'We sent you an email with instructions on how to reset your password.',
    if_you_do_not_receive: 'If you don\'t receive the email within a few minutes, {link} to try again.',
    resend_the_email: 'resend the email',
    back_to_browsing: 'Back To Browsing',
    back_to_bid: 'Back To Bid',
    bid_error: 'We\'re sorry, your bid was not successfully placed because of an error we encountered. Please place it again.',

    input_error: 'Input error',
    confirm_changes: 'Confirm Changes',
    confirm_changes_password: 'Please enter your password below to confirm your changes.',
    your_changes_have_been_saved: 'Your changes have been saved.',
    changes_saved: 'Changes Saved',

    // Auction Results
    auction_results_page_title: 'Search Auction Price Results - Live Auctioneers',
    auction_results_page_description: 'Search sold items.',
    auction_results_description: 'LiveAuctioneers’ Auction Price Results Database is a free research tool for those who want to buy or sell. Access 21 million art, antique, jewelry, furniture, collectible, and fashion results that were auctioned off from thousands of global auction houses. Search by keyword and refine by auction house, location, origin, style & period, creator, materials, techniques, and more to research and determine the value of items in your existing or future collection. Auction results are updated daily with new hammer prices so you can always access recently sold to historical results dating back to 1999. Whether you’re a collector wanting to know what price to pay; a consignor looking to learn the value of your property; an appraiser or estate office trying to evaluate a client’s possessions; or a journalist researching a given subject, our database is a valuable tool.',
    search_auction_price_results: 'Search Auction Price Results',
    see_auction_price_results_for: 'See {token} Auction Price Results',
    see_upcoming_category_items: 'See Upcoming {token} items',
    price_guide_results_how_much: 'How much is your',
    price_guide_results_worth: 'worth?',
    price_guide_results_value_of: 'Learn the market value of your',
    price_guide_results: 'Prices and Auction Results',
    price_guide_results_in: 'prices and auction results in',
    price_guide_results_research: 'Research',
    price_guide_title: 'Prices -',
    price_guid_discover: '{token} Prices and Auction Results',
    follow_search_tooltip: 'Follow to get email alerts when new {token} items arrive.',

    // Register
    back: 'Back',
    confirm: 'Confirm',
    register: 'Register',
    pending_approval: 'Pending Approval',
    bid_is_a_contract: 'Your bid is a contract',
    have_a_question_about_terms: 'Have a question about the terms?',
    auctioneer_terms_of_sale: 'Auctioneer terms of sale',
    yes_i_agree_to_the_terms: 'Yes, I agree to the terms of sale.',
    you_must_agree_to_the_terms: 'You must agree to the terms of sale.',
    place_a_bid_only_if_youre_serious: 'Place a bid only if you\'re serious about buying the item.',
    if_you_are_the_successful_and_winning_bidder: 'If you are the successful and winning bidder, you have entered into a legally binding contract to purchase the property from the seller.',
    you_should_contact_the_seller_to_resolve: 'You should contact the seller to resolve any questions before bidding.  You can find this option on the item\'s detail screen.',
    your_auction_registration_is_pending: 'Your auction registration is pending approval from the auctioneer.  Once you\'ve been approved you\'ll receive an email from us.',

    // Send Seller Message
    to: 'To',
    subject: 'Subject',
    get_answers_here: 'Get Answers Here',
    have_a_general_question: 'Have a general question?',
    message_the_auction_house: 'Message the Auction House',
    message: 'Message',
    send_message: 'Send Message',
    you_must_enter_a_message: 'You must enter a message.',
    looks_like_something_went_wrong: 'Looks like something went wrong on our end. Please try again.',
    message_sent: 'Your message has been sent',

    // Seller
    auction_ended: 'Auction Ended',
    ended: 'Ended',
    past: 'Past',
    page: 'page',
    upcoming: 'Upcoming',
    about_auctioneer: 'About Auctioneer',
    ends_sometime_onwards: 'Ends {endTime} {timeZoneAbbr} onwards',
    general_question: 'General Question',
    no_upcoming_auctions: '{auctionHouse} has no upcoming auctions. Follow this auctioneer to hear about new auctions.',
    past_auctions: 'Past Auctions',
    register_to_bid: 'Register to Bid',
    read_less: 'Read Less',
    read_more: 'Read More',
    starts_at: 'Starts at {startDate}',
    upcoming_auctions: 'Upcoming Auctions',
    upcoming_auctions_from: 'Upcoming Auctions from {name}',
    past_auctions_from: 'Past Auctions from {name}',
    search_upcoming_items: 'Search upcoming items',
    record_results_for: 'Record Auction Results for {name}',
    consign_item: 'Consign Item',
    see_all_price_results: 'See all price results',
    follow_this: 'Follow this',
    no_upcoming_auctions_message_not_followed: '{name} has no upcoming auctions. {cta} auctioneer to hear about new auctions.',
    no_upcoming_auctions_message_followed: 'You\'re following {name}. An email notification will be sent when their next auction is scheduled.',

    // Seller Directory
    auction_house_directory: 'Auction House Directory',
    search_directory: 'Search',
    enter_auction_name: 'Enter Auction Name:',
    see_upcoming_auctions: 'See Upcoming Auctions Near Me',
    find_4000_auction_houses: 'Find 4,000+ Auction Houses...',
    united_states: 'United States',
    europe: 'Europe',
    all_around_the_world: 'All Around the World',
    auction_house_directory_on_liveauctioneers: 'Auction House Directory on LiveAuctioneers',
    loading_auctioneers: 'Loading Auctioneers',
    directory_description: 'Find the auction house you are looking for in our 4,000+ registered auction houses',

    // Near me page
    loading_auctions: 'Loading Auctions',

    // footer
    // mobile
    bid_anywhere_anytime: 'Bid Anywhere, Anytime. Download the LiveAuctioneers App.',
    available_on_the_app_store: 'Available on the App Store',
    android_app_on_google_play: 'Android App on Google Play',

    // SEO
    popular_searches: 'Popular Searches',
    artists_and_creators: 'Artists & Creators',
    brands: 'Brands',
    style_periods: 'Style Periods',
    origins: 'Origins',

    // Support
    company: 'Company',
    about: 'About',
    careers: 'Careers',
    press: 'Press',
    auction_central_news: 'Auction Central News',
    support_center: 'Support Center',
    contact_us: 'Contact Us',
    winning: 'Winning',
    how_auctions_work: 'How Auctions Work',
    auction_calendar: 'Auction Calendar',
    auctions_near_you: 'Auctions Near You',
    auctions_near_me: 'Auctions Near Me',
    past_auction_results: 'Past Auction Results',
    all_auctions: 'All Auctions',
    auction_result_search: 'Auction Result Search',
    mobile: 'Mobile',
    selling: 'Selling',
    why_sell: 'Why Sell',
    become_a_seller: 'Become A Seller',
    consign_an_item: 'Consign An Item',
    auctioneer_sign_in: 'Auctioneer Sign In',
    using: 'Using',
    the_new_liveauctioneers_site: 'The New LiveAuctioneers Site',
    classic_site: 'Classic Site',
    copyright: '2002-2017 LiveAuctioneers. All Rights Reserved.',
    terms_and_conditions: 'Terms & Conditions',
    pr_services: 'PR Services',
    privacy_policy: 'Privacy Policy',
    loading: 'loading...',

    // Trust
    as_seen_on: 'As Seen On',
    shop_with_confidence: 'Shop With Confidence',
    since_2002_liveauctioneers_has_made_items: 'Since 2002, LiveAuctioneers has made exceptional items available for safe purchase in secure online auctions.',

    sorry_we_cant_find: 'Sorry! We can\'t find what you\'re looking for.',

    // Catalog Page
    search: 'Search',
    sort: 'Sort',
    select: 'Select',
    estimate_highest_first: 'Estimate: Highest',
    estimate_lowest_first: 'Estimate: Lowest',
    least_bids: 'Least Bids',
    most_bids: 'Most Bids',
    lot_number_highest_first: 'Lot Number: Highest',
    lot_number_lowest_first: 'Lot Number: Lowest',
    price_highest_first: 'Price: Highest',
    price_lowest_first: 'Price: Lowest',
    date_ascending: 'Date: Ascending',
    date_descending: 'Date: Descending',
    time_ending_furthest: 'Time: Ending Furthest',
    time_soonest_first: 'Time: Starting Soonest',
    saved_recent_first: 'Saved: Recent First',
    saved_oldest_first: 'Saved: Oldest First',
    bid_recent_first: 'Bid: Recent First',
    bid_oldest_first: 'Bid: Oldest First',
    result_recent_first: 'Result: Recent First',
    result_oldest_first: 'Result: Oldest First',
    name_highest_first: 'Name: Z to A',
    name_lowest_first: 'Name: A to Z',
    upcoming_highest_first: 'Upcoming Count: Decending',
    upcoming_lowest_first: 'Upcoming Count: Ascending',
    last_sent_ascending: 'Last Sent: Ascending',
    last_sent_descending: 'Last Sent: Descending',
    search_term_ascending: 'Search Term: A-Z',
    search_term_descending: 'Search Term: Z-A',
    less: 'Less',
    more: 'More',
    lots: 'Lots',
    done: 'Done',
    location: 'Location',
    auction_and_auctioneer_information: 'Auction & Auctioneer Information',
    contact_auctioneer: 'Contact Auctioneer',
    preview: 'Preview',
    view: 'View',
    all: 'All',
    auction_info: 'Auction Info',
    previous: 'Previous',
    next: 'Next',
    approved_to_bid: 'Approved to bid',
    you_can_bid_on_any_of_the_items: 'You can bid on any of the items in this auction.',
    try_another_search: 'Please try another search term.',
    results_for: '{count} results for',
    clear: 'Clear',
    loading_results: 'Loading Results...',
    show_all_upcoming_auctions: 'Show all upcoming auctions',

    // Search
    you_must_enter_a_min_value_less_than_max: 'Min must be less than the max.',
    you_must_enter_at_lease_one: 'Enter at least a min or max value.',
    you_must_enter_a_valid_zip_code: 'Enter a valid zip code.',
    search_item_count_items: '{count} items',
    search_show_results_for: 'Show results for:',
    search_see_more: '+ Show More',
    search_see_all: 'Show All',
    search_see_less: '- Show Less',
    search_distance_view_less_countries: 'Show Fewer Countries',
    search_distance_view_more_countries: 'Show More Countries',
    search_sort: 'SORT:',
    search_no_auction_house_found: 'No auction houses found.',
    search_no_creator_found: 'No creators found.',
    search_term_for: 'for',
    search_home: 'Home',
    search_see: 'See',
    search_upcoming_item: 'Upcoming Item',
    search_sold_item: 'Sold Item',
    search_results: 'results',
    search_minimum: 'min',
    search_maximum: 'max',
    search_no_results: 'No luck! We couldn\'t find any items matching your criteria.',
    search_no_results_create_alert: 'to get email alerts when new items matching your criteria are available at auction.',
    search_no_results_saved_alert: 'Following Search! We will send you email alerts when new items matching your criteria are available at auction.',
    search_error_1: 'Oops! We are having temporary technical difficulties.',
    search_error_2: 'Please try refreshing the page in 10 seconds, or ',
    search_error_contact_support: 'contact our Support Team',
    search_error_3: ' if the problem persists.',
    within: 'Within',
    anywhere: 'Anywhere',

    alert_created: 'Alert Created',
    your_alert_has_been_created: 'Your alert has been created.',

    // Upcoming Item Search Sorts
    '-relevance_upcoming': 'Best Match',
    '-popularity_upcoming': 'Most Popular',
    '-publishDate_upcoming': 'Newly Listed',
    saleStart_upcoming: 'Time: Starting Soonest',
    '-saleStart_upcoming': 'Time: Starting Furthest',
    '-currentBid_upcoming': 'Price: Highest',
    currentBid_upcoming: 'Price: Lowest',
    '-estimatedPrice_upcoming': 'Estimate: Highest',
    estimatedPrice_upcoming: 'Estimate: Lowest',
    '-bidCount_upcoming': 'Most Bids',
    bidCount_upcoming: 'Least Bids',

    // Sold Item Search Sorts
    '-relevance_sold': 'Best Match',
    '-popularity_sold': 'Most Popular',
    '-publishDate_sold': 'Newly Listed',
    saleStart_sold: 'Time: Oldest',
    '-saleStart_sold': 'Time: Newest',
    '-bidCount_sold': 'Most Bids',
    bidCount_sold: 'Least Bids',
    '-hammerPrice_sold': 'Price: Highest',
    hammerPrice_sold: 'Price: Lowest',

    // My Auctions Page
    approved: 'Approved',
    pending: 'Pending',
    auctions: 'Auctions',
    empty_approved_auction_message_part_1: 'Looks like you aren\'t registered to bid in any upcoming auctions.',
    empty_approved_auction_message_part_2: '{link} you love and register to bid in the auctions to win.',
    empty_pending_auction_message_part_1: 'You have no current pending registration approvals.',
    empty_pending_auction_message_part_2: '{link} and register to bid in an upcoming sale.',
    search_for_items: 'Search for items',
    search_for_items_now: 'Search for items now',

    // My bids page
    you_are_leading: 'You\'re Leading',
    reserve_not_met: 'Reserve not met',
    outbid: 'Outbid',
    not_approved: 'Not Approved',
    you_won: 'You Won!',
    lost: 'Lost',
    increase_bid_of: 'Increase Bid of {bidAmount}',
    increase_max_of: 'Increase Max Bid of {bidAmount}',
    enter_live_auction: 'Enter Live Auction',
    similar_items: 'Similar Items',
    view_similar_items: 'View Similar Items',
    the_item_is_damaged: 'The item is damaged or misrepresented',
    change_of_mind: 'Change of mind',
    found_another_item: 'Found another item',
    other: 'Other',
    please_explain: 'Please explain...',
    loading_my_bids: 'Loading Your Bids {loaded}/{loading}',
    empty_upcoming_bids_message_part_1: 'Looks like you don’t have any bids in upcoming auctions.',
    empty_upcoming_bids_message_part_2: 'Let’s fix that. {link} and start bidding (and winning!)',
    empty_past_bids_message_part_1: 'Bids for items in upcoming or live auctions will be in the Upcoming Tab.',
    empty_past_bids_message_part_2: 'After the auction, you\'ll find the items that you\'ve bid on here.',
    empty_past_bids_message_part_3: 'Head on over to {link} and start bidding (and winning!)',
    search_for_unique_items: 'search for unique items',
    search_for_unique_items_cap_start: 'Search for unique items',

    // Followed auctioneers
    auctioneers: 'Auctioneers',
    upcoming_auct: 'upcoming auctions',
    unfollow: 'unfollow',
    loading_followed_auctioneers: 'Loading Your Followed Auctioneers {loaded}/{loading}',
    fourk_experts: '4,000+ licensed auction experts',
    no_upcoming: 'No upcoming auctions',
    follow_any: 'Follow any of our {experts} to access their profile, auctions, and items.',
    click_follow: 'Click the "Follow" button on any auctioneer profile to add them to your list.',
    empty_save_message_part_1: 'Looks like you aren’t following any auction houses.',
    empty_save_message_part_2: 'You can keep up to date with your favorite auctioneers, by pressing the \'Follow\' button on their auctioneer profile page.',
    empty_save_message_part_3: 'Head on over to the {link} to find auctioneers in your area.',

    // Followed searches and alerts
    saved_searches: 'Followed Searches and Alerts',
    searches: 'Searches',
    never_miss_out: 'Never miss out on the items you\'re interested in.',
    add_alerts: 'Follow Searches to get a daily email of new matches and to browse them on this page.',
    recent_results: 'Recent Results',
    manage_alerts: 'Manage Alerts',
    sent: 'Sent',
    remove: 'Remove',
    never: 'Never',
    add_keyword_alert: 'Add Keyword Alert:',
    follow_search: 'Follow Search',
    advanced_alerts: 'Advanced Alerts',
    advanced_alerts_popover_text: 'Create search alerts that are refined by auction house, price range, location, and more. Search for items, refine your results, and then click "Create Search Alert"',
    rolex_eames_chair: 'i.e. Rolex, Eames Chair...',
    loading_saved_searches: 'Loading Your Followed Searches {loaded}/{loading}',
    loading_saved_search_items: 'Loading Your Followed Search Items {loaded}/{loading}',
    empty_manage_alerts_message_part_1: 'You haven’t saved any searches!',
    empty_manage_alerts_message_part_2: 'Enter a search term in the box above and click \'Follow Search\' to add a search alert. You\'ll be notified when items matching that term are available for bidding.',
    empty_manage_alerts_message_part_3: 'Search alerts can also be created on the {link}. Enter a search term, filter down by your wanted criteria and click onto \'Follow Search\'.',
    search_page: 'search page',
    empty_recent_results_message_part_1: 'Bummer. There are no recent items that match any of your saved searches.',
    empty_recent_results_message_part_2: 'Matching items may appear in time. Expand your treasure hunt and {link} to find more interesting items.',
    save_new_searches: 'save new searches',

    // Category Pages
    follow_category: 'Follow',
    unfollow_category: 'Unfollow',
    following_category: 'Following',

    // Follow Search
    save_search_save: 'FOLLOW SEARCH',
    save_search_saved: 'FOLLOWING SEARCH',
    save_search_create_search_alert_link: 'Follow this search',

    // Search Facet Titles
    search_facet_title_auctionHouse: 'Auction House',
    search_facet_title_F1: 'Categories',
    search_facet_title_F2: 'Origin',
    search_facet_title_countryCode: 'Location',
    search_facet_title_currentBid: 'Current Bid',
    search_facet_title_materialsAndTechniques: 'Material / Technique',
    search_facet_title_stylePeriod: 'Style / Period',
    search_facet_title_creator: 'Creator',
    search_facet_title_estimate: 'Estimate',
    search_facet_title_hammerPrice: 'Sold For',

    // Search Input
    search_input_sold: 'Sold',
    search_input_upcoming: 'Upcoming',
    search_input_search_past_auction_price_results: 'Search past auction price results',
    search_input_search_for_items_and_auction_houses: 'Search for items and auction houses',

    // Breadcrumbs
    back_to_auction: 'Back to Auction',
    back_to_search: 'Back to Search',
    view_auction: 'View Auction',

    // Account Settings Page
    account_settings_page_description: 'Change your account settings',
    my_profile: 'My Profile',
    email_preferences: 'Email Preferences',
    change_password: 'Change Password',
    account_update_error: 'We\'re sorry, we were unable to update your account at this time. Please try again.',
    newsletters: 'Newsletters',
    frequency: 'Frequency',
    email_alerts: 'Email Alerts',
    real_time_alerts: 'Real Time Alerts',

    // Near me page
    find_auctions_near_me: 'Find Auctions Near Me',
    find_auctions_description: 'Find auctions from thousands of auctioneers near you on an interactive map. Then bid live online on art, antiques, jewelry and collectibles from around the world.',
    find_auctions_on_a_map: 'Find auctions near an area on a map. Then browse auction catalogs from thousands of auctioneers to bid live online on art, antiques, jewelry, and collectibles.',
    enter_location: 'Enter Location:',
    city_zip_or_postal_code: 'City, ZIP, or Postal Code...',

    // Seller Testimonials page
    seller_testimonials: 'Seller Testimonials',
    what_our_clients_say: 'What our clients say about us',
    comment1_0: '“The New York Times, New York Post, CBS This Morning, The Huffington Post, Associated Press, The Miami Herald, Vogue Italia, Canadian-Latin American-German press agencies, print media and websites-blogs-tweets-Facebook entries worldwide… all writing, tweeting and talking about our January 19, 2013, auction and all because LiveAuctioneers PR Services let the world know about it.',
    comment1_1: 'The result: our best auction to date, with 690 registered bidders, 568 bids, 186,000 page views, 20,000+ visitors and $330,000 in winning bids, and all that just on LiveAuctioneers.com! That doesn’t include, as a result of your PR work, the record 400+ in-house bidders, phone bidders or left bids that all contributed to a million-dollar auction. The sheer numbers, in terms of sales and bidders, were way beyond our expectations, but you gave us even more, something you can’t pay for… EDITORIAL, exposing our auction house all over the world!',
    comment1_2: 'You shared our passion about the auction, worked hard (even on nights and weekends) and relentlessly pursued every possible PR lead. We really don’t know how to thank you; you have energized and set the new standard for Palm Beach Modern Auctions.',
    comment1_3: 'I would recommend your services to any auction house looking to increase their sales or company presence in the auction world.”',
    comment2: '“Collectors all over the world really like LiveAuctioneers. The format is simple to use, and it has become a very good highway for bidding in our sales. The age of reservation about bidding online is over; it took a company like LiveAuctioneers, which has proven itself, to make that happen. We have been very pleased.”',
    comment3: '“LiveAuctioneers allows us to reach an entirely new audience of potential buyers around the world who can then take part in our auctions ‘live’ on the day. It has had a significant impact on the success of our business.”',
    comment4: '“I used to pride myself in having a strong international clientele through phone, mail and fax bidding, but with the addition of LiveAuctioneers, my worldwide client base has increased exponentially. After my last sale, I shipped merchandise to Finland, Denmark, France, Germany, Austria, England, Belgium, the Netherlands, Portugal, Spain, Mexico, New Zealand, Australia, Japan, Canada, Singapore and even to one bidder in Czechoslovakia. It’s amazing that all these people are just a mouse click away.”',
    comment5: '“In a nutshell, I wouldn’t be in business without LiveAuctioneers. Our auctions average a 35-40% sell-through with the site, and on many occasions we’ve approached the 50% mark online. LiveAuctioneers has brought us customers from all over the world, including some very good regular buyers in Turkey, Israel and other countries.”',
    comment6: '“This last sale was a huge success and the participation through LiveAuctioneers was one of, if not the, highest, so far. It was one of our higher-end sales. We’re seeing a shift in the population that typically bids with us online—a good shift.”',
    comment7: '“Online bidding is the staple of any successful auction these days. And having a great online bidding system, like LiveAuctioneers, is critical.”',
    comment8: '“Thanks so much for an awesome auction. You all have been a huge part of our business. It seems almost flawless and the bidders seem to find the process so much easier. You all have really built something valuable!”',
    comment9: '“Thank you for your help in getting us started. Had it not been for the assistance of your tremendously helpful staff, the auction would not have been the success that it was. Our low estimates were in the $120,000 range, and actual sales were $264,000. Not bad at all!”',
    comment10: '“Working with LiveAuctioneers was a fantastic experience for my nonprofit organization. As a public charity, we rely on a variety of means to raise funds. You folks helped us launch our first-ever online auction and it was a tremendous success on a few different levels. First, we exceeded our revenue goals. But perhaps equally important, we did this without eating up a lot of our small staff’s valuable time. The tools that LiveAuctioneers provided us with were invaluable and easy to use. I look forward to working with you again in the future.”',
    comment11: '“It’s been a week since our New Year’s auction and we have been struggling to find the right words to describe our first experience with LiveAuctioneers PR Services. Beyond expectations? Incredible? We could not believe the response, not just in the U.S. but around the world. We sold $70,000 to Russian bidders and close to $80,000 to China, in addition to the U.S. and other countries. We were on TV, radio, in newspapers and magazines, on collector sites, the Internet and on top of the search engines. Fabulous! We had over 70,000 hits on LiveAuctioneers, alone, before the auction. Beyond expectations! Just before the auction we took a late consignment and mentioned it to Catherine at LiveAuctioneers. Two days later, it was picked up by major collector sites. Incredible!”',
    comment12: '“Just wanted to take the time to tell you that you and your staff are doing a great job! My staff couldn’t be happier with how things are going for us with LiveAuctioneers. The new reports are fabulous. The gentlemen that handle the phones are courteous and oh so patient. Kudos.”',
    comment13_0: '“There is no denying that LiveAuctioneers has helped our auction company expand our business. Since we started using their online auction service, our prices have only increased. We have seen thousands of people look at our auctions and have received hundreds of absentee bids, and this is just for one auction! Having several of these auctions has only proved that we are reaching a broader audience than we could have ever imagined.',
    comment13_1: 'We just held a ‘country store-style’ auction a few weeks ago. Many items sold to online bidders for 2x or 3x the value that we could have gotten here at our auction house. Some items had 30-60 bids; the majority of the bidders were online. It is hard to believe the whole world is watching your auction house, but it is true. For this sale alone, we had hundreds of bidders from all across the U.S. and various countries. Working with LiveAuctioneers has been a great experience. With just a little extra work, our auction company is now known across the world.”',
    comment14: '“It’s now the third live auction we have done with LiveAuctioneers, and all we can say is: thank you! Thank you for your professional and fast support, thank you for your effort to improve and adjust your system to the needs of your customers. It’s good to have real people on the phone when you need them and it’s good to get an answer no matter how dull the question. Life would be easier on the web and a better place if there were more companies like LiveAuctioneers.”',
    comment15: '“It was an immense pleasure to have LiveAuctioneers help us through our first live auction 5 months ago. They are a benchmark for what excellent support should be.”',
    comment16: '“Stout Auctions has used LiveAuctioneers numerous times and we have been exceedingly happy with the results and the service they have offered. One improvement in particular convinced me to write this, and that service is the new invoicing system. No one else has an invoicing system like LiveAuctioneers; it literally saves me a full day of sorting out buyers, shipping costs, emails etc. Keep this up and you’re going to have to buy eBay!”',
    comment17: '“I have just been reviewing the new bidder approval process for our current auction. I must say that I am always stunned at how well LiveAuctioneers pioneers this industry we all love. This approval process is ingenious. I am quite sure that a tremendous amount of time and resources were poured into creating this option to assist the auction houses. I am proud to have our auction house as one of your clients. Thank you for breaking down the walls for all us brick & mortar auction galleries who just simply cannot do what you have done, and have done better than anyone else. Continue to educate the world about the joy of auctions and you will always have my support.”',
    comment18: '“After using other service providers with online auctions (via eBay and others), we are very pleased with LiveAuctioneers. The service has been great, the back-end administration features are excellent, and the ease of use is appreciated as well. We are most pleased with the post-auction reports and the detailed item reports, allowing us to tweak item descriptions to find the most buyers. We’ll continue to use LiveAuctioneers as our service provider for our online auctions. Thanks!”',
    comment19: '“Your entire company is nothing short of fantastic!“',

    // About us page
    about_us: 'About Us',
    about_us_1: 'LiveAuctioneers brings an international audience of millions to the heart of the bidding action in art, antiques, jewelry and collectibles auctions across the globe.',
    about_us_2: 'With fascinating objects up for bid in 47 countries—instantly translated to your language and currency—LiveAuctioneers is a worldwide marketplace with treasures waiting to be discovered, whether you\'re an avid collector or a first-time visitor.',
    about_us_3: 'By hosting thousands of auctions in real time via the Internet, the site allows unprecedented access to remote sales, and savvy bidders can often land desired items at very desirable prices. Leave an absentee bid, or fully engage in the auction action—it\'s up to you. All bidding takes place via the Secure Bidder Network (SBN), which keeps absentee bids for upcoming sales private until the item is opened on the day of the sale.',
    about_us_4: 'LiveAuctioneers revolutionized the industry from the start. In 2002, the NYC-based company formed a marketing partnership with eBay to introduce eBay Live Auctions. This alliance of LiveAuctioneers and eBay enabled auction houses worldwide to go online with their live sales — a development that changed the auction business forever. In 2009, the debut of LiveAuctioneers\' iPhone and Android apps, with live-bidding capabilities, opened up a new mobile pipeline to bid anytime, from anywhere, with complete anonymity.',
    about_us_5: 'Now in its 14th year, LiveAuctioneers has become the Web\'s leading auction-related site. LiveAuctioneers also provides a constant stream of industry intelligence via:',
    about_us_6: 'The easy-to-use {auctionResults}, a vast database with 12.9 million results that offers keyword-search access to bona fide auction outcomes, recent to historical. The updated archive is the #1 free online resource for the trade, appraisers, collectors, designers, arts institutions, estate officers, journalists, students and others on the research hunt;',
    auction_results_database: 'Auction Results Database',
    about_us_7: '{auctionCentral}, the global destination for the latest auction headlines, mixing timely items with articles by experts on all things design.',

    // Privacy Policy Page
    la_privacy_policy: 'LiveAuctioneers Privacy Policy',
    our_commitment_to_privacy: 'Our Commitment To Privacy',
    commitment_to_privacy_body: 'LiveAuctioneers is committed to maintaining user privacy on the Live Auctioneers\' website at www.liveauctioneers.com (the "Site"). Our Private Policy governs use of personal information provided to us through the use of the Site. By accessing the Site you agree to be bound by the terms and conditions of this Privacy Policy. If you do not agree to its terms and conditions, you should not use or access our Site. By accepting the Privacy Policy, you expressly consent to our use and disclosure of your personal information in accordance with the policy. The Privacy Policy is incorporated into and subject to the terms of any agreement you sign with LiveAuctioneers and becomes applicable upon our acceptance of you as a registered user. If you have any additional questions about our Privacy Policy, please feel free to contact us at {mailTo}',
    use_of_site_by_children: 'Use of Our Site by Children',
    child_policy_body: 'Children (persons under the age of 18) are not eligible to use the Site unsupervised and we ask that children do not submit any personal information. If you are under the age of 18, you may only use this Site in conjunction with and under the supervision of parents or guardians.',
    information_we_collect: 'Information We Collect',
    information_collect_body: 'If you choose to use our services, we may require that you provide contact and identity information, billing information, shipping information, as well as other personal information as indicated on the forms throughout the Site. Where possible, we indicate fields that are required and those that are optional. You are not required to provide information if you choose not to use a particular service or feature. Please be advised that we may use your financial information, including credit card information, to verify the accuracy of your name, address, and other personal information, as well as to bill you for use of our services. Certain information is automatically tracked based on your activity on the Site. We use this information for internal research on user demographics, interests, and behavior so as to better understand, protect and serve you and our community. This information may include the URL that you previously visited (whether this URL is on the Site or not), the subsequent URL you visited (whether this URL is on the Site or not), your computer browser information, and your IP address. We may collect browser and Internet-related information through access to our Site, via cookies, and/or web beacons. If you send us personal correspondence, such as emails or letters, or if other users or third parties send us correspondence regarding your activities or postings on the Site, we may accumulate such information into a file specific to you.',
    our_use_of_your_information: 'Our Use of Your Information',
    our_use_your_information_body: 'We use your personal information to facilitate the services you personally request. Your contact information and bidding history will be passed onto the Auction Companies during the auction sign-up process for them to make a decision whether you are able to bid in their auction. We also use your personal file information and activity information to: resolve disputes; troubleshoot problems; collect fees owed; measure consumer interest in our products and services; inform you about online and offline offers, products, services, and updates; customize your experience; detect and protect us against error, fraud and other criminal activity; enforce applicable agreements; and as otherwise described to you at the time of collection. Providing us with your personal information indicates that you agree to our use of any personal information to improve our marketing and promotional efforts, to analyze Site usage, improve our content and product offerings, and customize the Site\'s content, layout, and services. In turn, we are able to improve the Site and better tailor it to meet your needs, providing you with a smooth, efficient, safe and customized experience. We also reserve the right to use your information to make contact and deliver information that, in some cases, is targeted to your interests. Examples include targeted banner advertisements, administrative notices, product offerings, and communication relevant to your use of the Site. By accepting this Privacy Policy, you expressly agree to receive this information, however, you may contact us at {mailTo} should you wish to cease receipt of such information.',
    our_disclosure_of_your_information: 'Our Disclosure of Your Information',
    our_disclosure_your_information_body: 'While we use your information to provide you with access to our site and services, we also use your information to contact you regarding our services, offerings, or information you may have requested. We use your information to improve and personalize our Site so as to make it easier, safer, and quicker to use. Due to the existing regulatory environment, we cannot ensure that all of your private communication and other personal information will never be disclosed in ways not otherwise described in this Privacy Policy. By way of example (without limiting the foregoing), we may be forced under certain circumstances to disclose personal information to the government or third parties, unaffiliated parties may unlawfully intercept or access transmissions or private communication, or users may abuse or misuse your personal information collected from the Site. Therefore, although we use industry standard practices to protect your privacy, we do not promise, and you should not expect, that your personal information or private communication will always remain completely private.',
    security: 'Security',
    security_body: 'We store your information in the United States. In order to prevent unauthorized access, maintain data accuracy, and ensure appropriate use of information, we use industry-leading technical and administrative practices and procedures that safeguard and secure your information.',
    notice: 'Notice',
    notice_body: 'We may occasionally choose to amend this Privacy Policy to better reflect our use and protection of your information. In the event of revision, all terms shall become effective within 15 days of initial posting to the Site.',
    last_updated: 'Last updated: February 6, 2013',

    // Features Page
    features_and_services: 'Features & Services for Auctioneers',
    feature_blurb: 'Live online auctions deliver a powerful trifecta: the potential of thousands of new customers, increased average hammer prices and dramatically fewer unsold items. Using LiveAuctioneers tools and features, you can track and analyze performance while tapping into the global Internet marketplace to build your business:',
    live_bidding: 'Live Bidding',
    live_bidding_blurb: 'This allows bidders to place bids at the same time as the auction is actually taking place. The process is similar to telephone bidding, but much faster. Bidders can bid online using their computer, or via iPhone, iPad or Android apps.',
    absentee_bidding: 'Absentee Bidding',
    absentee_bidding_blurb: 'Once visitors have found an item that interests them, they can leave a bid online. A simple bidding form on the item description page allows them to leave a maximum bid before the sale starts. The bid is recorded and presented to the auctioneer via the live console when the auction starts.',
    auctioneer_dashboard: 'Auctioneer Dashboard',
    auctioneer_dashboard_blurb: 'The go-to for everything involving a LiveAuctioneers account. From step-by-step auction set-up to bidder registration and approval, it\'s all organized, along with email messaging, access to marketing services and helpful guides and forms, just a click away.',
    our_network: 'Our Network',
    our_network_blurb: 'Our live network runs on multiple server clusters located in two different regions of the US to ensure redundancy. Our East Coast and Southern US data centers have fully redundant battery power, generator back-up and massive connectivity, utilizing such reliable network providers as Level 3, Global Crossing and Congent. A team of technologists dedicated to network and server maintenance ensures the reliability of a complex custom system configuration to handle millions of live bidding transactions daily.',
    catalog_set_up: 'Catalog Set-up',
    catalog_set_up_blurb: 'Item descriptions, images, estimated selling prices and contact details encourage visitors to view your catalogs before registering to bid. After a catalog has been published on LiveAuctioneers, registered bidders can view items and leave absentee bids, or wait to bid live on the day of the sale.',
    bidder_management: 'Bidder Management & Approve, Block, Set as Regular',
    bidder_management_blurb: 'This feature enables your company to review and approve bidders based on past online activity. It can be done manually or with set criteria, which automatically approves bidders meeting those conditions.',
    inbox_messaging: 'Inbox Messaging',
    inbox_messaging_blurb: 'This makes communication with bidders easy and centralized, offering you the chance to receive and reply to bidder questions throughout the auction process. All bidder conversations are threaded, linked to bidder profiles, and can be sorted info folders.',
    statistics_tracking: 'Statistics Tracking',
    statistics_tracking_blurb: 'Tracks how many times each item was viewed, number of visitors and referring URLs.',
    self_service_upload: 'Self-Service Upload',
    self_service_upload_blurb: 'Makes it possible for you to upload images and catalogs directly into the LiveAuctioneers system 24/7.',
    automated_online_console: 'Automated Online Console',
    automated_online_console_blurb: 'The automated console has the same look and feel of a standard auction, with the key added benefit of running an unmanned online auction, if you prefer.',
    end_of_auction_report: 'End-of-Auction Report',
    end_of_auction_report_blurb: 'A performance report sent via email with critical statistics: sales totals, visits, hits, bidder registrations and more from a recent auction.',
    live_items_widget: 'Live Items Widget and Live Catalog Widget',
    live_items_widget_blurb: 'Live Items Widget displays live items directly on the your website in a 220x200 window. Live Catalog Widget displays the entire catalog on your website in the gallery layout.',
    qr_code: 'QR Code',
    qr_code_blurb: 'A QR code image can be added to your print ads, allowing smart phone users to go directly to your catalog.',
    staff_permission_levels: 'Staff Permission Levels',
    staff_permission_levels_blurb: 'Permission access levels for your staff can be set within a LiveAuctioneers account.',
    weekly_newsletter: 'Weekly Newsletter',
    weekly_newsletter_blurb: 'This newsletter is sent to bidders weekly, with links to upcoming auctions.',
    help_files: 'Help Files',
    help_files_blurb: 'This comprehensive tool helps to answer questions about running a sale online, including demo videos and detailed steps.',
    bidder_contact_and_invoicing: 'Bidder Contact and Invoicing',
    bidder_contact_and_invoicing_blurb: 'This feature enables you to contact winning bidders with customized emails or invoices within minutes of the auction close, avoiding the time-consuming task of invoicing. LiveAuctioneers\' fully automated system also allows a buyer to complete his/her purchase online.',
    paypal: 'PayPal',
    paypal_blurb: 'The platform receives automated bidder payment notifications from PayPal.',
    accounting: 'Accounting',
    accounting_blurb: 'This makes it easy to track auction accounting information.',
    white_label_platform: 'White-Label Platform',
    white_label_platform_blurb: 'This option allows you to customize the live bidding console and run live auctions directly from your website.',
    api_integration: 'API Integration',
    api_integration_blurb: 'Your auction management software can seamlessly integrate with LiveAuctioneers\' database through this function.',

    // How it Works Page
    how_to_buy_at_auction: 'How to Buy at Auction',
    bidding_on_la_is_easy: ' Bidding on LiveAuctioneers is easy - and you can do it from any internet connect device, anywhere!',
    step_one: 'Register For Free',
    step_one_blurb: 'Join the community with the largest collection of storied items.',
    step_two: 'Place Your Bids',
    step_two_blurb: 'Many items start at just $1. Place bids and get approved.',
    step_three: 'Ensure You Win',
    step_three_blurb: ' Watch the live auction to ensure you win. See all the action.',
    step_four: 'Pay If You Win',
    step_four_blurb: 'Only if you win will you be asked to pay and arrange shipping.',

    // Price Gateway
    price_gateway_item_page: 'Sign Up For Sold Price',
    price_gateway_card: 'See Sold Price',

    auction_terminology: 'Auction Terminology',

    intellectual_property: 'Intellectual Property',

    // buyers premium
    middle_low_cut_off: '{middle}% above',
    middle_cut_off: '{middle}% up to',
    high_cut_off: '{high}% above',
    low_cut_off: '{low}% up to',
    low_percentage: '{low}%',

    // banners
    be_a_part_of_the_savviest: 'Be a part of the savviest, smartest group of collectors worldwide',
    hunt_like_a_vintage_shop_owner: 'Hunt like a vintage shop owner',
    join_the_community: 'Join the community',
    start_your_treasure_hunt: 'Start your treasure hunt',
    access_200000_new_items_every_week: 'Access 200,000 new items every week, from anywhere',
    your_next_great_find: 'Your next great find is here',
    get_started: 'Get started',

    lets_go_treasure_hunting: 'Let\'s go treasure hunting',
    browse_popular_items: 'Browse popular items',
    find_exceptional_fine_art: 'Find exceptional fine art, collectibles, and décor in online auctions',

    explore_collections_from_the_worlds_top: 'Explore collections from the world\'s top auction specialists',
    browse_collectibles: 'Browse collectibles',

    search_auction_results_from: 'Search auction results from 1000s of auctioneers',
    find_the_perfect_auction_house: 'Find the perfect auction house to sell your items',
    search_price_results: 'Search Price Results',

    // consignments
    consign_items_to_an_auction: 'Consign Items To An Auction',
    why_consign_with_us: 'Why Consign with Us',
    how_did_you_aquire: 'How did you acquire this item?',
    how_to_consign_items_to_seller: 'How to Consign Items with {sellerName}',
    consign_description_1: 'LiveAuctioneers\' mission is to connect buyers with sellers of quality goods. If you own an item(s) you would like to consign, we can help make that key connection to our more than 4,000 auctioneers.',
    consign_description_1_seller: 'LiveAuctioneers\' mission is to connect buyers with sellers of quality goods. If you own an item(s) you would like to consign, we can help connect you with {sellerName}.',
    consign_description_2_title: 'Consignment Process:',
    consign_description_2: 'We assist in the sale of your property by providing a secure, neutral platform in which buyers and sellers worldwide may establish contact. Please complete the online form with item details. Your item will be listed and available for review and evaluation by all auctioneers on our site. If an auctioneer is interested in your item, their staff will get in touch with you.',
    consign_description_2_seller: '{title} We assist in the sale of your property by providing a secure, neutral platform in which buyers and sellers worldwide may establish contact. Please complete the online form with item details. Your item will be listed and available for review and evaluation by {sellerName}. If {sellerName} is interested in your item, their staff will get in touch with you.',
    consign_description_3_title: 'Please Note:',
    consign_description_3: '{title} Estimates are not provided through this process. If you are seeking an estimate for your item, please contact a local auction house. LiveAuctioneers does not act as an agent for your merchandise, nor do we in any way make representations with respect to the authenticity or value of your material goods.',
    photo: 'Photo',
    value: 'Value',
    i_bought_it: 'I bought it',
    i_inherited_it: 'I inherited it',
    i_found_it: 'I found it',
    it_was_a_gift_it: 'It was a gift',
    log_in_to_consign: 'Log in to consign',
    successfully_submitted: 'Successfully Submitted',
    general_description: 'General Description',
    description: 'Description',
    physical_details: 'Physical Details',
    consignment_submitted: 'Consignment Submitted',
    submit_another_consignment: 'Submit Another Consignment',
    browse_la: 'Browse LiveAuctioneers',
    your_consignment_has_been_submitted: 'Your consignment has been submitted. If an auctioneer is interested, they will contact you directly.',
    other_help: 'Further information that will help in the sale of your property',
    description_help: 'Please describe your item an as much details as possible. Please include details like what is it made of, who made it, when, the items condition, included documentations, marks or signatures',
    details_help: 'Dimensions, manufacturers’ marks, condition (and details regarding any exceptions to condition), material or medium (if artwork), etc.',
    category: 'Category',
    your_item_is_being_shared: 'Your item is now being shared with 4000 of the world\'s best auction houses.  What happens next? * If an auction house is interested, they\'ll contact you directly via e-mail.',
    twentieth_century: '20th Century',
    autographs: 'Autographs',
    books: 'Books',
    commercial: 'Commercial',
    decorative_arts: 'Decorative Arts',
    entertainment: 'Entertainment',
    fine_art: 'Fine Art',
    rugs_and_carpets: 'Rugs/Carpets',
    toys: 'Toys',
    please_choose_a_photo: 'Please choose a photo to upload.',
    there_was_an_error_submitting_consignment: 'We experienced an error trying to submit your consignment.  Please try again later.',

    item_description: 'Item Description',

    ok: 'ok',
    cancel: 'cancel'
};

exports.default = en;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/intl/en.js
// module id = eNmu
// module chunks = 46